export const langList = [
    {id:2, title:'Arabic', active:false},
    {id:1, title:'Urdu', active:false},
    {id:2, title:'Kurdish', active:false},
    {id:3, title:'English', active:false},
    {id:4, title:'Japanese', active:false},
    {id:4, title:'Chechen', active:false},
    {id:4, title:'Circassian', active:false},
    {id:5, title:'Russian', active:false},
];

export const skillList = [
    {id:1,name:'WordPress', description:'Template and extensions.', star:4 },
    {id:2,name:'Laravel', description:'Most popular framework of php langauge and easy to use', star:3 },
];


export const featureList = [
    {
        position:'C++ Developer',
        company: 'Microsoft',
        start: '03/09/2025',
        working: true,
        end:false,
        city:'Egypt',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure dolorem ex doloremque laboriosam quidem rem incidunt esse atque voluptatum aut, beatae labore ipsum nulla deserunt itaque molestias nisi quasi veniam.',
    },
    {
        position:'Kernel Engineer',
        company: 'Oracle Inc.',
        start: '03/07/2025',
        working: true,
        end:'01/03/2025',
        city:'Canada',
        description:'Iure dolorem ex doloremque laboriosam quidem rem incidunt deserunt itaque molestias  esse atque voluptatum aut, beatae labore ipsum veniam.',
    }
    ]